// Components==============
import { useRedux } from './useRedux';
// =========================

export function useToken(
  activity?: ProcessEntity | { process_id: number; process_type: ProcessType },
  requirement?: RequirementEntity
) {
  const token = useRedux((state) => {
    if (activity)
      return activity?.process_type === 'App\\Phase'
        ? state.phase?.entities.byId[activity.process_id]
        : activity?.process_type === 'App\\Training'
        ? state.training?.entities.byId[activity.process_id]
        : activity?.process_type === 'App\\Activity'
        ? state.activity?.entities.byId[activity.process_id]
        : undefined;

    if (requirement)
      return requirement?.requirement_type === 'App\\Phase'
        ? state.phase?.entities.byId[requirement.requirement_id]
        : requirement.requirement_type === 'App\\Training'
        ? state.training?.entities.byId[requirement.requirement_id]
        : requirement.requirement_type === 'App\\Activity'
        ? state.activity?.entities.byId[requirement.requirement_id]
        : undefined;

    return undefined;
  });
  return token;
}
